var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { eager: "", persistent: "", "max-width": "350" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "div",
        { staticClass: "chooser" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "cyan darken-1 headline" },
                [
                  _c("span", { staticClass: "white--text" }, [
                    _vm._v("Chi inizia?"),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { depressed: "", light: "", icon: "" },
                      on: { click: _vm.dismiss },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("si-sta-facendo-asta-per"),
              _vm._v(" "),
              _vm.asta_choosers && _vm._.size(_vm.asta_choosers) > 0
                ? _c(
                    "v-list",
                    _vm._l(_vm.asta_choosers, function (squadraChooser) {
                      return _c(
                        "v-list-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                squadraChooser.canBeChooser == true ||
                                _vm.showAll,
                              expression:
                                "squadraChooser.canBeChooser == true || showAll",
                            },
                          ],
                          key: squadraChooser.id,
                          attrs: {
                            disabled: squadraChooser.canBeChooser == false,
                          },
                          on: {
                            click: function ($event) {
                              squadraChooser.canBeChooser == true
                                ? _vm.select(squadraChooser.id)
                                : null
                            },
                          },
                        },
                        [
                          _c("v-list-item-avatar", [
                            _c("img", {
                              attrs: {
                                src: _vm.squadra(squadraChooser.id).pic,
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(squadraChooser.name)),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-action",
                            [
                              _vm.asta_round.chooser == squadraChooser.id
                                ? _c("v-badge", {
                                    staticClass: "ma-1",
                                    attrs: {
                                      inline: "",
                                      color: "cyan",
                                      content: "Ultimo chiamante",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              squadraChooser.canBeChooser == false
                                ? _c("v-badge", {
                                    staticClass: "ma-1",
                                    attrs: {
                                      inline: "",
                                      color: "grey",
                                      content: squadraChooser.msgIfNotChooser,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.asta_choosers &&
              _vm._.size(_vm.asta_choosers) == _vm.nSquadreNonSelezionabili
                ? _c("div", { staticClass: "lista-vuota" }, [
                    _c("span", [_vm._v("Nessuno ha il diritto di chiamare ")]),
                    _vm._v(" "),
                    _vm.ruolo_da_chiamare !=
                    _vm.Constants.RUOLO_DA_CHIAMARE.QUALUNQUE
                      ? _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.Constants.RUOLI_NEW[_vm.ruolo_da_chiamare]
                                  .plurale
                              )
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.nSquadreNonSelezionabili > 0
                ? _c(
                    "div",
                    { staticClass: "pa-4 text-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "cyan--text",
                          attrs: {
                            outlined: "",
                            depressed: "",
                            small: "",
                            rounded: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.showAll = !_vm.showAll
                            },
                          },
                        },
                        [
                          !_vm.showAll
                            ? _c("span", [_vm._v("Mostra tutti")])
                            : _c("span", [_vm._v("Solo selezionabili")]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }